import { AgGridReact } from "ag-grid-react";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import { academylist } from "../../../services/admin";
import { deletecompbook, listcompbook } from "../../../services/common";
import Swal from "sweetalert2";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from "chart.js";
import { Bar } from "react-chartjs-2";
import ChartDataLabels from "chartjs-plugin-datalabels";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartDataLabels);

function buildMonthChart(data) {
  if (!data || data.length === 0) return null;
  const grouped = {};
  data.forEach((item) => {
    const month = moment(item.complaint_date, "DD-MM-YYYY").format("MMM YYYY");
    if (!grouped[month]) grouped[month] = { total: 0, high: 0, medium: 0, low: 0 };
    grouped[month].total += 1;
    if (item.priority === "High") grouped[month].high += 1;
    else if (item.priority === "Medium") grouped[month].medium += 1;
    else if (item.priority === "Low") grouped[month].low += 1;
  });
  const labels = Object.keys(grouped).sort((a, b) =>
    moment(a, "MMM YYYY").valueOf() - moment(b, "MMM YYYY").valueOf()
  );
  if (labels.length === 0) return null;
  return {
    labels,
    datasets: [
      { label: "Total", data: labels.map((l) => grouped[l].total), backgroundColor: "rgba(98,89,202,0.8)" },
      { label: "High", data: labels.map((l) => grouped[l].high), backgroundColor: "rgba(241,109,117,0.85)" },
      { label: "Medium", data: labels.map((l) => grouped[l].medium), backgroundColor: "rgba(247,183,49,0.85)" },
      { label: "Low", data: labels.map((l) => grouped[l].low), backgroundColor: "rgba(25,177,89,0.85)" },
    ],
  };
}

const MONTH_CHART_OPTIONS = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: { position: "top" },
    datalabels: {
      color: "#fff",
      anchor: "end",
      align: "start",
      font: { weight: "bold", size: 11 },
      formatter: (value) => (value > 0 ? String(value) : ""),
    },
  },
  scales: {
    x: { title: { display: true, text: "Month", color: "#666", font: { size: 13, weight: "bold" } } },
    y: { beginAtZero: true, title: { display: true, text: "Count", color: "#666", font: { size: 13, weight: "bold" } } },
  },
};

export default function Allcomplaints() {
  const navigate = useNavigate();
  const [filterProduct, setFilterProduct] = useState([]);
  const [fdate, setFDate] = useState("");
  const [tdate, setTDate] = useState("");

  const [aclist, setACList] = useState([]);
  const [acaid, setAcaID] = useState("");


  const columnDefs = [
    {
      headerName: "Actions",
      width: 100,
      field: "id",
      resizable: true,
      filter: false,
      cellRenderer: function (params) {
        return (
          <div className="text-center">
            <a
              onClick={() =>
                navigate(`/complaints/complaintdetail/${params.value}`)
              }
              className="btn-sm btn-info me-2"
            >
              <i className="fa fa-edit"></i>
            </a>
            <a
              onClick={() => deleteenq(params.value)}
              className="btn-sm btn-danger"
            >
              <i className="fa fa-trash"></i>
            </a>
          </div>
        );
      },
    },
    {
      headerName: "Date",
      field: "complaint_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Name",
      field: "complaint_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Complaint",
      field: "complaint_reason",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Priority",
      field: "priority",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
  ];

  const columnDDefs = [
    {
      headerName: "Date",
      field: "complaint_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },

    },
    {
      headerName: "Name",
      field: "complaint_name",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Phone",
      field: "phone",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Complaint",
      field: "complaint_reason",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Priority",
      field: "priority",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
    },
    {
      headerName: "Deleted Date",
      field: "updated_date",
      sortable: true,
      resizable: true,
      filter: true,
      floatingFilter: true,
      cellStyle: { textAlign: "left" },
      cellRenderer: function (params) {
        return moment(params.value).format("DD-MM-YYYY");
      },
    },
  ];
  const location = useLocation();
  const [urllink, setUrllink] = useState("");
  useEffect(() => {
    setFDate(moment(new Date()).format("YYYY-MM-DD"));
    setTDate(moment(new Date()).format("YYYY-MM-DD"));
    const path = location.pathname.split("/")[2];
    setUrllink(path);

    academylist().then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.details.length > 0) {
          for (let i = 0; i < res.data.details.length; i++) {
            arr.push({
              value: res.data.details[i].id,
              label:
                res.data.details[i].name + " - " + res.data.details[i].code,
            });
          }
          setACList(arr);
        }
      }
    });
    if (localStorage.getItem("AAcademy") != null) {
      academylist().then((res) => {
        if (res.status === true) {
          let arr = [];
          if (res.data.details.length > 0) {
            for (let i = 0; i < res.data.details.length; i++) {
              if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                arr.push({
                  value: res.data.details[i].id,
                  label:
                    res.data.details[i].name + " - " + res.data.details[i].code,
                });
              }
              if (arr.length > 0) {
                setAcaID(arr[0]);

              }
            }

          }
        }
      });
    } else {
      setAcaID("");
    }
    if (localStorage.getItem("ADate") !== '') {
      setFDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      setTDate(moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"));
      listall(
        "",
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        moment(localStorage.getItem("ADate")).format("YYYY-MM-DD"),
        path
      );
    } else {
      setFDate(moment(new Date()).format("YYYY-MM-DD"));
      setTDate(moment(new Date()).format("YYYY-MM-DD"));
      listall(
        "",
        moment(new Date()).format("YYYY-MM-DD"),
        moment(new Date()).format("YYYY-MM-DD"),
        path
      );
    }
  }, [location.pathname]);

  function listall(aid, fdte, tdte, ltype) {
    setFDate(fdte);
    setTDate(tdte);
    setFilterProduct([]);
    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("from_date", fdte);
    temp.append("to_date", tdte);
    if (ltype === "deletecomplaints") {
      temp.append("status", 0);
    } else {
      temp.append("status", 1);
    }
    listcompbook(temp).then((res) => {
      if (res.status === true) {
        const role = localStorage.getItem("Role");
        if (role === "1" || role === "2") {
          if (res.data.details.length > 0) {
            const cdata = res.data.details.map((item) => ({
              ...item,
              complaint_date: moment(item.complaint_date).format("DD-MM-YYYY"),
            }));
            setFilterProduct(cdata);
          }
        } else {
          const cdata = res.data.details.filter((item) => item.created_by == localStorage.getItem("UID"));
          if (cdata.length > 0) {
            const ddata = cdata.map((item) => ({
              ...item,
              complaint_date: moment(item.complaint_date).format("DD-MM-YYYY"),
            }));
            setFilterProduct(ddata);
          }
        }
      }
    });
  }

  function deleteenq(did) {
    Swal.fire({
      text: "Are you sure want to delete?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#ac0404",
      cancelButtonColor: "#6259ca",
      confirmButtonText: "Delete",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        deletecompbook(did).then((response) => {
          if (response.status === true) {
            navigate("/complaints/deletecomplaints");
          }
        });
      }
    });
  }

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listall(e, fdate, tdate, urllink);
    } else {
      setAcaID("");
      listall("", fdate, tdate, urllink);
    }
  }

  return (
    <div>
      <div className="page-header">
        {urllink === "deletecomplaints" && (
          <h2 className="main-content-title tx-24 mg-b-5">Delete Complaints</h2>
        )}
        {urllink === "allcomplaints" && (
          <h2 className="main-content-title tx-24 mg-b-5">All Complaints</h2>
        )}
        <ol className="breadcrumb">
          <li className="breadcrumb-item">
            <a>Complaint Book</a>
          </li>
          {urllink === "deletecomplaints" && (
            <li className="breadcrumb-item active" aria-current="page">
              Delete Complaints
            </li>
          )}
          {urllink === "allcomplaints" && (
            <li className="breadcrumb-item active" aria-current="page">
              All Complaints
            </li>
          )}
        </ol>
      </div>
      <div className="content-body">
        <div className="container-fluid">
          <div className="row">
                {localStorage.getItem("Role") === "1" && (
                  <div className="col-lg-4">
                    <label className="form-label">
                      Select Academy <span className="text-danger"> *</span>
                    </label>
                    <Select
                      className="default-select"
                      placeholder="Select Academy"
                      value={acaid}
                      options={aclist}
                      onChange={handleAcademy}
                      isSearchable={true}
                      isClearable
                      hidden
                    />
                  </div>
                )}

                <div className="col-lg-4">
                  <label className="form-label">From Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) =>
                      listall(acaid, e.target.value, tdate, urllink)
                    }
                    value={fdate}
                  />
                </div>
                <div className="col-lg-4">
                  <label className="form-label">To Date</label>
                  <input
                    type="date"
                    className="form-control"
                    onChange={(e) =>
                      listall(acaid, fdate, e.target.value, urllink)
                    }
                    value={tdate}
                  />
                </div>
              </div>
              {urllink === "allcomplaints" && filterProduct.length > 0 && (
                <div className="row row-sm mt-3 mb-2">
                  <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card custom-card" style={{ borderTop: "3px solid #6259ca" }}>
                      <div className="card-body text-center py-3">
                        <h2 className="mb-1 font-weight-bold text-primary">{filterProduct.length}</h2>
                        <p className="text-muted mb-0">Total Complaints</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card custom-card" style={{ borderTop: "3px solid #f16d75" }}>
                      <div className="card-body text-center py-3">
                        <h2 className="mb-1 font-weight-bold text-danger">
                          {filterProduct.filter((i) => i.priority === "High").length}
                        </h2>
                        <p className="text-muted mb-0">High Priority</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card custom-card" style={{ borderTop: "3px solid #f7b731" }}>
                      <div className="card-body text-center py-3">
                        <h2 className="mb-1 font-weight-bold text-warning">
                          {filterProduct.filter((i) => i.priority === "Medium").length}
                        </h2>
                        <p className="text-muted mb-0">Medium Priority</p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-3 col-md-6 mb-3">
                    <div className="card custom-card" style={{ borderTop: "3px solid #19b159" }}>
                      <div className="card-body text-center py-3">
                        <h2 className="mb-1 font-weight-bold text-success">
                          {filterProduct.filter((i) => i.priority === "Low").length}
                        </h2>
                        <p className="text-muted mb-0">Low Priority</p>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {urllink === "allcomplaints" && (() => {
                const chart = buildMonthChart(filterProduct);
                return chart ? (
                  <div className="card custom-card mt-3">
                    <div className="card-body">
                      <div className="text-center mb-3">
                        <h5 style={{ fontWeight: "bold", margin: 0 }}>Complaint Analysis</h5>
                        <p className="text-muted tx-12 mb-0">Month Wise — Total, High, Medium &amp; Low Priority</p>
                      </div>
                      <div style={{ height: Math.max(300, chart.labels.length * 60) + "px", width: "100%" }}>
                        <Bar data={chart} options={MONTH_CHART_OPTIONS} />
                      </div>
                    </div>
                  </div>
                ) : null;
              })()}
              <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                  columnDefs={
                    urllink === "deletecomplaints" ? columnDDefs : columnDefs
                  }
                  rowData={filterProduct}
                  pagination="true"
                  paginationPageSize="10"
                  sortingOrder={["asc", "desc"]}
                  suppressDragLeaveHidesColumns={true}
                />
              </div>
        </div>
      </div>
    </div>
  );
}
